import React, { useEffect } from "react";
import "./index.m.css";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import { CloseIcon } from "../auto-modal/icons"; // reuse the CloseIcon from auto-modal

export const AutoRenewelModal = ({ onClose, expiryDate }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div styleName="overlay" onClick={onClose}>
      <div styleName="popupContainer" onClick={(e) => e.stopPropagation()}>
        <CloseIcon styleName="closeIcon" onClick={onClose} />

        <h2 styleName="title">{SUBSCRIBE_PAGE_TEXT.AUTORENEWAL_SUCCESS_TITLE}</h2>
        <p styleName="description">{SUBSCRIBE_PAGE_TEXT.AUTORENEWAL_SUCCESS_DESC.replace("[Expiry Date]", expiryDate || "")}</p>

        <button styleName="okButton" onClick={onClose}>
          {SUBSCRIBE_PAGE_TEXT.AUTORENEWAL_SUCCESS_BTN}
        </button>
      </div>
    </div>
  );
};
